import { getFilterDataAPI } from "Api/filterDataAPI";
import { useGlobalContext } from "context/globalContext";
import { useCallback, useEffect } from "react";

export const useFilterDataHook = () => {
  const { setFilterData } = useGlobalContext();
  const getFilterdata = useCallback(async () => {
    const token = localStorage.getItem("jwtToken");
    const response = await getFilterDataAPI(
      {
        name: ["prompt", "destination", "config", "promptFragment"],
      },
      () => {},
      token
    );
    if (response) {
   
      setFilterData(response);
    }
  }, [setFilterData]);

  useEffect(() => {
    getFilterdata();
  }, [getFilterdata]);

  return {};
};
